export * from "./RecipesPage";

export { default } from "./RecipesPage";
